import script from "./BlogPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__